import _ from 'lodash';
export default function reducer(
  state = {
    List: [],
    FormActive: 'List',
    Trainer: [],
    Count: {},
    Selected: {},
    SelectedId: [],
    SelectList: [],
    Loading: 'RETRIEVING',
    CurrentData: {},
    Filter: {
      name: '',
    },
    NotificationSetting: {},
    Default: {
      commentReplies: 1,
      fileCommented: 1,
      fileNewUpload: 1,
      fileReplies: 1,
      fileTagged: 1,
      messageMentioned: 1,
      messageSend: 1,
      addedToAccount: 1,
      receiveEmail: 1,
      taskApproved: 1,
      taskApprover: 1,
      taskApproverChangeRequest: 1,
      taskAssigned: 1,
      taskAssignedComment: 1,
      taskBeforeDeadline: 0,
      taskDeadline: 0,
      taskFollowingCompleted: 0,
      taskFollowingDeadline: 0,
      taskMemberCompleted: 1,
      taskReviewer: 1,
      taskReviewerChangeRequest: 1,
      taskSubmittedApproval: 1,
      taskSubmittedReview: 1,
      taskTagged: 1,
      taskTeamDeadline: 1,
    },
  },
  action
) {
  switch (action.type) {
    case 'ADD_USER_LIST': {
      return { ...state, List: state.List.concat(action.List) };
    }
    case 'SET_USER_LIST': {
      return { ...state, List: action.list, Count: action.Count };
    }
    case 'SET_TRAINER_LIST': {
      return { ...state, Trainer: action.list };
    }
    case 'SET_USER_SELECT_LIST': {
      return { ...state, SelectList: action.List, Loading: '' };
    }
    case 'SET_USER_FORM_ACTIVE': {
      return { ...state, FormActive: action.FormActive };
    }
    case 'SET_USER_SELECTED': {
      return { ...state, Selected: action.Selected };
    }
    case 'SET_USER_ID': {
      return { ...state, SelectedId: action.SelectedId };
    }
    case 'SET_CURRENT_DATA_SELECTED': {
      return { ...state, CurrentData: action.Selected };
    }
    case 'UPDATE_DATA_USER_LIST': {
      let tempList = state.List.map((e, i) => {
        if (e.id === action.UpdatedData.id) {
          return action.UpdatedData;
        }
        return e;
      });
      return { ...state, List: tempList };
    }
    case 'UPDATE_USER_TEAM': {
      let tempList = _.map(state.List, function (obj) {
        return _.assign(obj, _.find(action.List, { id: obj.id }));
      });

      return { ...state, List: tempList };
    }
    case 'REMOVE_DELETED_USER_LIST': {
      let tempList = state.List.filter((e, i) => {
        if (action.Id !== e.id) {
          return e;
        }
      });
      return { ...state, List: tempList };
    }
    case 'SET_USER_STATUS': {
      let List = state.List.map((e, i) => {
        if (e.id === action.record.id) {
          e.Active = action.record.status;
          return e;
        } else {
          return e;
        }
      });
      return { ...state, List: List };
    }
    case 'SET_USER_LOADING': {
      return { ...state, Loading: action.Loading };
    }
    case 'SET_USER_FILTER': {
      const { Filter } = { ...state };
      const updatedFilter = _.assign({}, Filter, action.filter);
      return { ...state, Filter: updatedFilter };
    }
    case 'SET_USER_NOTIFICATION_SELECTED': {
      return { ...state, NotificationSetting: action.Setting };
    }
    case 'RESET_NOTIFICATION_SETTING': {
      return { ...state, NotificationSetting: state.Default };
    }
    default:
      return state;
  }
}
